import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Alert } from 'antd';
import { get } from 'api/api';
import Dashboard from 'components/Dashboard/Dashboard.container';
import SignageItem from 'components/Dashboard/Signage/SignageItem';
import ShareLink from '../../components/Dashboard/Share';

const Signage = () => {
  const [signages, setSignages] = useState([]);
  const params = useParams();
  const storeId = useMemo(() => (params.storeId ? Number(params.storeId) : null), [params.storeId]);

  const getSignages = () => {
    const url = `/services/store/${storeId}/signages/`;
    const promise = get(url, {});
    promise
      .then((res) => {
        setSignages(res.data);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error.message);
      });
  };
  useEffect(() => {
    getSignages();
  }, []);

  return (
    <Dashboard page="signage" storeId={storeId} doShowHeader>
      {storeId ? (
        <Row style={{ maxWidth: '1440px', margin: '0 auto' }}>
          <Row style={{ padding: '24px 24px 24px' }}>
            <Col span={24}>
              <span>Switch your sign any time. And don’t forget to </span>
              <ShareLink
                className="Signage_ShareLink"
                storeId={storeId}
                text="share your store link"
                color="primary"
                inline
              />
              <span> with your guests!</span>
            </Col>
          </Row>
          <Row style={{ padding: '24px 24px 24px' }} gutter={[16, 16]}>
            {signages.map((item, index) => (
              <SignageItem
                key={index}
                index={index}
                storeId={storeId}
                src={item.preview}
                imageId={item.imageId}
                title={item.label}
                data={item}
                onClick={setSignages}
              />
            ))}
          </Row>
        </Row>
      ) : (
        <Row style={{ padding: '24px 24px 24px' }}>
          <Alert message="You have no Store for signages" type="error" />
        </Row>
      )}
    </Dashboard>
  );
};

export default Signage;
